export default __webpack_public_path__ + "static/media/leed_registro_sume_v.f81e0cea.png";